import { useIsAuthenticated } from '../auth';
import { Button, HStack, Icon } from '@chakra-ui/react';
import { Result } from '@ssar-app/uikit';
import { useHistory } from 'react-router-dom';
import { AiOutlineDoubleLeft } from 'react-icons/ai/index.js';
import { FaSignOutAlt } from 'react-icons/fa/index.js';

export const PageNotFound = () => {
  const history = useHistory();
  const isAuthed = useIsAuthenticated();
  return (
    <Result
      status='404'
      title='404'
      subTitle='Sorry, the page you visited does not exist.'
      extra={
        <HStack>
          <Button
            colorScheme='gray'
            variant='outline'
            leftIcon={<Icon as={AiOutlineDoubleLeft} />}
            onClick={() => {
              history.goBack();
            }}
          >
            &nbsp; Back
          </Button>
          {isAuthed && (
            <Button
              colorScheme='blue'
              leftIcon={<Icon as={FaSignOutAlt} />}
              onClick={() => {
                history.replace('/logout');
              }}
            >
              &nbsp; Logout
            </Button>
          )}
        </HStack>
      }
    />
  );
};
